import React from 'react';
import { CircularProgress } from 'material-ui/Progress';


const LoadingSpinner = () => (
  <div className="container">
    <div className="spinner">
      <CircularProgress
        style={{ color: '#0095d5' }}
      />
      <p className="loadingText">Loading...</p>
    </div>
  </div>
);

export default LoadingSpinner;



// WEBPACK FOOTER //
// src/components/atoms/LoadingSpinner/index.jsx